<template>
 <div>
    <loader :show="enviando"/>
    <b-modal  v-model="mostrar" size="small" title="Agregar puesto Público o Privado" hide-footer  hide-header-close no-close-on-backdrop>   
    <b-card-body>   
       <b-form-group label="Seleccione el tipo de puesto">
       <b-form-select
            class="mb-3"
            v-model="tipoForm"
            :options="ambito"
            :disabled="tipoPuesto !== null"
            
          ></b-form-select>
       </b-form-group>
      <b-row v-if="tipoForm == 'PÚBLICO'" >
       

        <b-col md="6">
        <b-form-group label="País de la institución ">
          <b-form-select
            class="mb-3"
            v-model="publico.ubicacion"
            :options="pais"
          
          ></b-form-select>
        </b-form-group>
        </b-col>

        <b-col md="6">
        <b-form-group label="Nivel u orden de Gobierno: ">
          <b-form-select
          
            @change="cambios = true"
            :options="nivelOrdenGobierno"
            v-model="publico.nivelOrdenGobierno"
            class="mb-3"
          ></b-form-select>
        </b-form-group>
        </b-col>

        <b-col md="6">
        <b-form-group label="Ámbito Público: ">
          <b-form-select
          
            @change="cambios = true"
            :options="ambitoPublico"
            v-model="publico.ambitoPublico"
            class="mb-3"
          ></b-form-select>
        </b-form-group>
        </b-col>

        <b-col md="12">
        <b-form-group  label ="Institución/Empresa/Nombre, denominación o razón social">
          <b-form-input
          
            @change="cambios = true"
            v-model="publico.nombreEntePublico"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
        </b-col>

        <b-col md="12">
        <b-form-group label="Unidad administrativa/Área:">
          <b-form-input
     
            @change="cambios = true"
            v-model="publico.areaAdscripcion"
             placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
        </b-col>

        <b-col md="12">
        <b-form-group>
          <label>Puesto o cargo desempeñado:</label>
          <b-form-input
            @change="cambios = true"
            v-model="publico.empleoCargoComision"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
        </b-col>

        <b-col md="12">
        <b-form-group label="Función principal">
          <b-form-input
            @change="cambios = true"
            v-model="publico.funcionPrincipal"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
        </b-col>

        <b-col md="6">
        <b-form-group label="Ingreso:">
          <datetime
            :input-class="'form-control input'"
            v-model="publico.fechaIngreso"
            placeholder="Selecciona fecha"
          />
        </b-form-group>
        </b-col>
       
        <b-col md="6">
        <b-form-group label="Egreso:">
          <datetime
           :input-class="'form-control input'"
            v-model="publico.fechaEgreso"
            placeholder="Selecciona fecha"
          />
        </b-form-group>
        </b-col>
       
        
        <b-col style="text-align: center">
          <b-button
             variant="danger"
              size="sm"
              @click="$emit('cancelar')"
              >Cancelar</b-button>
        </b-col>
        <b-col style="text-align: center">
          <b-button
              variant="primary"
              size="sm"
              @click="guardarPuestoPublico()"
              >Guardar Puesto</b-button>
            <br />
            <p v-if="cambios" class="error-text">
              <i>No se han guardado los cambios</i>
            </p>
        </b-col>
      </b-row>
      <b-row v-else  >
      <b-col md="6">
        <b-form-group label="Sector Privado ">
          <b-form-select
            @change="cambios = true"
            :options="sectorPrivado"
            v-model="privado.sector.clave"
            class="mb-3"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="País de la institución">
          <b-form-select
            class="mb-3"
            v-model="privado.ubicacion"
            :options="pais"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group>
          <label>Institución/Empresa/Nombre, denominación o razón social:</label>
          <b-form-input
            @change="cambios = true"
            v-model="privado.nombreEmpresaSociedadAsociacion"
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group>
          <label for="RFC">RFC:</label>
          <b-form-input
    
            @change="cambios = true"
            v-model="privado.rfc"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label for="area">Área:</label>
          <b-form-input
         
            @change="cambios = true"
            v-model="privado.area"
           placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label for="puesto">Puesto o cargo desempeñado:</label>
          <b-form-input

            @change="cambios = true"
            v-model="privado.puesto"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Ingreso:">
          <datetime
        
            :input-class="'form-control input'"
            v-model="privado.fechaIngreso"
            type="date"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Egreso:">
          <datetime
            :input-class="'form-control input'"
            v-model="privado.fechaEgreso"
            type="date"
          />
        </b-form-group>
      </b-col>
    

       <b-col style="text-align: center">
        <b-button
          variant="danger"
          size="sm"
          @click="$emit('cancelar')"
          >Cancelar</b-button>
        </b-col>
        <b-col style="text-align: center">
         <b-button
          variant="primary"
          size="sm"
          @click="guardarPuestoPrivado()"
          >Guardar Puesto</b-button>
          <p v-if="cambios" class="error-text">
            <i>No se han guardado los cambios</i>
          </p>
        </b-col>


    </b-row>

      
 

    </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { required } from "vuelidate/lib/validators";


export default {
  name:"FormPuesto",
  components: { Loader, Datetime,  },
  props: ['mostrar', 'puesto', 'tipoPuesto'],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  validations:{
   
  },
  data: function() {
    return {
      enviando: false,
      cambios: false,
      tipoForm:null,
      publico:{         
        ambitoSector: { clave: null, valor: null },
        nivelOrdenGobierno: null,
        ambitoPublico: null,
        nombreEntePublico: null,
        areaAdscripcion: null,
        empleoCargoComision: null,
        funcionPrincipal: null,
        fechaIngreso: null,
        fechaEgreso: null,
        ubicacion: null
      },
      privado:{
          ambitoSector: { clave: null, valor: null},
          nombreEmpresaSociedadAsociacion: null,
          rfc: null,
          area: null,
          puesto: null,
          sector: { clave: null, valor: null },
          fechaIngreso: null,
          fechaEgreso: null,
          ubicacion: null
      },
      // tipoTrabajo: ["Público", "Privado", "Otro"],
      nivelOrdenGobierno: ["FEDERAL", "ESTATAL", "MUNICIPAL ALCALDIA"],
      ambitoPublico: [
        "EJECUTIVO",
        "LEGISLATIVO",
        "JUDICIAL",
        "ORGANO AUTONOMO"
      ],
      sectorPrivado: [
        { clave: "AGRI", valor: "AGRICULTURA" },
        { clave: "MIN", valor: "MINERÍA" },
        { clave: "EELECT", valor: "ENERGÍA ELÉCTRICA" },
        { clave: "CONS", valor: "CONSTRUCCIÓN" },
        { clave: "INDMANU", valor: "INDUSTRIA MANUFACTURERA" },
        { clave: "CMAYOR", valor: "COMERCIO AL POR MAYOR" },
        { clave: "CMENOR", valor: "COMERCIO AL POR MENOR" },
        { clave: "TRANS", valor: "TRANSPORTE" },
        { clave: "MEDIOM", valor: "MEDIOS MASIVOS" },
        { clave: "SERVFIN", valor: "SERVICIOS FINANCIEROS" },
        { clave: "SERVINM", valor: "SERVICIOS INMOBILIARIOS" },
        { clave: "SERVPROF", valor: "SERVICIOS PROFESIONALES" },
        { clave: "SERVCORP", valor: "SERVICIOS CORPORATIVOS" },
        { clave: "SERVS", valor: "SERVICIOS DE SALUD" },
        { clave: "SERVESPAR", valor: "SERVICIOS DE ESPARCIMIENTO" },
        
      ],
      pais: ["MÉXICO" ,"EXTRANJERO" ],
      ambito:['PÚBLICO', 'PRIVADO']    
 
    };
  },
  watch:{
    'tipoForm':function(val){
      if(val=='PRIVADO'){
        this.privado.sector.clave = this.puesto ? this.puesto.sector.clave :this.sectorPrivado[0].clave;
        this.privado.sector.valor = this.puesto ? this.puesto.sector.valor : this.sectorPrivado[0].valor;
        this.privado.ubicacion= this.puesto? this.puesto.ubicacion : this.pais[0]
      }
      else{
        this.publico.ambitoPublico = this.ambitoPublico[0]
        this.publico.nivelOrdenGobierno = this.nivelOrdenGobierno[0]
        this.publico.ubicacion=this.pais[0]
      }
    }
  
  },
  methods: {
     guardarPuestoPublico() {
      this.enviando = true;
      if (!this.puesto) {
      
        axios.post(this.httpURL +"/declaraciones/V2/experienciaLaboral/" +this.$route.params.id + "/sectorPublico",
            {
              tipoOperacion:'AGREGAR',
              ambitoSectorClave: 'PUB',
              ambitoSectorValor: 'PUBLICO',
              nivelOrdenGobierno: this.publico.nivelOrdenGobierno,
              ambitoPublico: this.publico.ambitoPublico,
              nombreEntePublico: this.publico.nombreEntePublico,
              areaAdscripcion: this.publico.areaAdscripcion,
              empleoCargoComision: this.publico.empleoCargoComision,
              funcionPrincipal: this.publico.funcionPrincipal,
              fechaIngreso: this.publico.fechaIngreso,
              fechaEgreso: this.publico.fechaEgreso,
              ubicacion: this.publico.ubicacion
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            //console.log(res);
            this.enviando = false;
            if (res.data.ok) {
              this.$notify({group: "foo",type: "success",duration: 2500, speed: 1000,text: res.data.mensaje});
              this.$emit('publicoAgregado',res.data.sectorPublico)
            }
          })
          .catch(error => {
            
            this.$notify({ group: "foo",type: "error",duration: 2500, speed: 1000, text: "No se pudo guardar la sección."});
            this.enviando = false;
          });
      } 
      else {
 
        axios.put( this.httpURL +"/declaraciones/V2/experienciaLaboral/" +this.$route.params.id + "/sectorPublico/" + this.puesto._id,
            {
              tipoOperacion: 'MODIFICAR',
              ambitoSectorClave: 'PUB',
              ambitoSectorValor: 'PUBLICO',
              nivelOrdenGobierno: this.puesto.nivelOrdenGobierno,
              ambitoPublico: this.puesto.ambitoPublico,
              nombreEntePublico: this.puesto.nombreEntePublico,
              areaAdscripcion: this.puesto.areaAdscripcion,
              empleoCargoComision: this.puesto.empleoCargoComision,
              funcionPrincipal: this.puesto.funcionPrincipal,
              fechaIngreso: this.puesto.fechaIngreso,
              fechaEgreso: this.puesto.fechaEgreso,
              ubicacion: this.puesto.ubicacion
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
//            console.log(res);
            if (res.data.ok) {
              this.$notify({ group: "foo", type: "success", duration: 2500, speed: 1000,text: res.data.mensaje });
              this.$emit('publicoModificado', res.data.sectorPublico)
            }
            this.cambios = false;
            this.enviando = false;
          })
          .catch(error => {
            //console.log(error);
            this.$notify({group: "foo",type: "error", duration: 2500, speed: 1000,  text: "No se pudo guardar la sección."  });
            this.enviando = false;
          });
      }
    },

    guardarPuestoPrivado() {
      this.enviando = true;
      if (!this.puesto) {
       
        axios.post(this.httpURL +"/declaraciones/V2/experienciaLaboral/" +this.$route.params.id +"/sectorPrivado",
            {
              tipoOperacion: 'AGREGAR',
              ambitoSectorClave: 'PRIV',
              ambitoSectorValor: 'PRIVADO',
              nombreEmpresaSociedadAsociacion: this.privado.nombreEmpresaSociedadAsociacion,
              rfc: this.privado.rfc,
              area: this.privado.area,
              puesto: this.privado.puesto,
              sectorClave: this.privado.sector.clave,
              sectorValor: this.privado.sector.valor,
              fechaIngreso: this.privado.fechaIngreso,
              fechaEgreso: this.privado.fechaEgreso,
              ubicacion: this.privado.ubicacion
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
        //console.log(res);
            if (res.data.ok) {
              this.$notify({ group: "foo", type: "success", duration: 2500,speed: 1000,text: res.data.mensaje });
              this.$emit('privadoAgregado', res.data.sectorPrivado)
            }
            this.enviando = false;
            this.cambios=false;
          })
          .catch(error => {
            this.$notify({group: "foo", type: "error",duration: 2500,speed: 1000, text: "No se pudo guardar la sección."});
            this.enviando = false;
          });
      }
      else {
        //let index = this.sectorPrivado.findIndex(x =>x.clave == this.puesto.sector.clave);
        axios.put(this.httpURL +"/declaraciones/V2/experienciaLaboral/" + this.$route.params.id +"/sectorPrivado/" + this.puesto._id,
            {
              tipoOperacion: 'MODIFICACION',
              ambitoSectorClave: 'PRIV',
              ambitoSectorValor: 'PRIVADO',
              nombreEmpresaSociedadAsociacion: this.puesto.nombreEmpresaSociedadAsociacion,
              rfc: this.puesto.rfc,
              area: this.puesto.area,
              puesto: this.puesto.puesto,
              sectorClave: this.puesto.sector.clave,
              sectorValor: this.puesto.sector.valor,
              fechaIngreso: this.puesto.fechaIngreso,
              fechaEgreso: this.puesto.fechaEgreso,
              ubicacion: this.puesto.ubicacion
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            //console.log(res)
            if (res.data.ok) {
              this.$notify({ group: "foo", type: "success",duration: 2500, speed: 1000,   text: res.data.mensaje   });
              this.$emit('privadoModificado', res.data.sectorPrivado)
            }
            this.cambios = false;
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({group: "foo",type: "error", duration: 2500,speed: 1000, text: "No se pudo guardar la sección."});
            this.enviando = false;
          });
      }
    },
    
  },
  created(){
    this.tipoForm = this.tipoPuesto ? this.tipoPuesto : 'PÚBLICO'
   
    if(this.puesto){
     
      if(this.tipoForm == 'PÚBLICO') this.publico = this.puesto 
      else this.privado = this.puesto
    }
    else{
      if(this.tipoForm=='PÚBLICO'){
          // this.publico.ambitoSector.clave = "PUB"
          // this.publico.ambitoSector.valor = "PÚBLICO"
          this.publico.ambitoPublico = this.ambitoPublico[0]
          this.publico.nivelOrdenGobierno = this.nivelOrdenGobierno[0]
          this.publico.ubicacion=this.pais[0]
      }
    
    }
  }

};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
